import { createContext, useReducer, useRef } from "react";
// import { screenSize, userData } from "three/tsl";

export const AppContext = createContext();

const initialState = {
    showExtraPage: false,
    ready: false,
    modelLoaded: false,
    userLoaded: false,
    fabricLoaded: false,
    fabricData: {},
    userData: {},
    favourite: false,
    fabricPrice: 0,
    fabricCategory: "",
    fabricCategoryTitle: "",
    fabricPattern: "",
    fabricShirt: "",
    fabricTexture: "",
    fabricTile: "",
    fabricView: null,
    collar: "",
    cuff: "",
    cuffMesh: "",
    cuffPrice: 0,
    cuffCategory: "",
    cuffButtons: 0,
    monogram: false,
    monogramPrice: 0,
    monogramText: "",
    monogramLocation: "",
    monogramFontStyle: "",
    monogramColor: "",
    pocket: "",
    pocketPrice: 0,
    contrast: "",
    contrastPrice: 0,
    stitch: false,
    stitchPrice: 0,
    stitchColor: "",
    tuxedo: "",
    tuxedoPrice: 0,
    placket: "",
    placketPrice: 0,
    visibleMesh: [
        'Shirt', 'Neck', 'ButtonArm', 'HoleArm', 'ButtonNeck', 'HoleNeck', 'HoleSet1', 'HoleSet2',
        'ButtonSet1', 'ButtonSet2'
    ],
    subMenu: false,
    orientation: "landscape",
    menu: null,
    done: false,
    tooltip: { visible: false, display: false, text: "", x: 0, y: 0 }
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_SHOW_EXTRA_PAGE":
            return { ...state, showExtraPage: action.payload };
        case "SET_DONE":
            return { ...state, done: action.payload };
        case "SET_MENU":
            return { ...state, menu: action.payload };
        case "SET_ORIENTATION":
            return { ...state, orientation: action.payload };
        case "SET_MODEL_LOADED":
            return { ...state, modelLoaded: action.payload };
        case "SET_FABRIC_LOADED":
            return { ...state, fabricLoaded: action.payload };
        case "SET_USER_LOADED":
            return { ...state, userLoaded: action.payload };
        case "SET_USER_DATA":
            return { ...state, userData: action.payload };
        case "SET_FAVOURITE":
            return { ...state, favourite: action.payload };
        case "SET_FABRIC_DATA":
            return { ...state, fabricData: action.payload };
        case "SET_FABRIC_PRICE":
            return { ...state, fabricPrice: action.payload };
        case "SET_FABRIC_CATEGORY":
            return { ...state, fabricCategory: action.payload };
        case "SET_FABRIC_CATEGORY_TITLE":
            return { ...state, fabricCategoryTitle: action.payload };
        case "SET_FABRIC_PATTERN":
            return { ...state, fabricPattern: action.payload };
        case "SET_FABRIC_SHIRT":
            return { ...state, fabricShirt: action.payload };
        case "SET_FABRIC_TEXTURE":
            return { ...state, fabricTexture: action.payload };
        case "SET_FABRIC_TILE":
            return { ...state, fabricTile: action.payload };
        case "SET_FABRIC_VIEW":
            return { ...state, fabricView: action.payload };
        case "SET_COLLAR":
            return { ...state, collar: action.payload };
        case "SET_CUFF":
            return { ...state, cuff: action.payload };
        case "SET_CUFF_MESH":
            return { ...state, cuffMesh: action.payload };
        case "SET_CUFF_PRICE":
            return { ...state, cuffPrice: action.payload };
        case "SET_CUFF_CATEGORY":
            return { ...state, cuffCategory: action.payload };
        case "SET_CUFF_BUTTON":
            return { ...state, cuffButtons: action.payload };
        case "SET_MONOGRAM":
            return { ...state, monogram: action.payload };
        case "SET_MONOGRAM_PRICE":
            return { ...state, monogramPrice: action.payload };
        case "SET_MONOGRAM_TEXT":
            return { ...state, monogramText: action.payload };
        case "SET_MONOGRAM_LOCATION":
            return { ...state, monogramLocation: action.payload };
        case "SET_MONOGRAM_FONT_STYLE":
            return { ...state, monogramFontStyle: action.payload };
        case "SET_MONOGRAM_COLOR":
            return { ...state, monogramColor: action.payload };
        case "SET_POCKET":
            return { ...state, pocket: action.payload };
        case "SET_POCKET_PRICE":
            return { ...state, pocketPrice: action.payload };
        case "SET_CONTRAST":
            return { ...state, contrast: action.payload };
        case "SET_CONTRAST_PRICE":
            return { ...state, contrastPrice: action.payload };
        case "SET_STITCH":
            return { ...state, stitch: action.payload };
        case "SET_STITCH_PRICE":
            return { ...state, stitchPrice: action.payload };
        case "SET_STITCH_COLOR":
            return { ...state, stitchColor: action.payload };
        case "SET_TUXEDO":
            return { ...state, tuxedo: action.payload };
        case "SET_TUXEDO_PRICE":
            return { ...state, tuxedoPrice: action.payload };
        case "SET_PLACKET":
            return { ...state, placket: action.payload };
        case "SET_PLACKET_PRICE":
            return { ...state, placketPrice: action.payload };
        case "SET_VISIBLE_MESH":
            return { ...state, visibleMesh: action.payload };
        case "SET_READY":
            return { ...state, ready: action.payload };
        case "SHOW_TOOLTIP":
            return { ...state, tooltip: { ...state.tooltip, text: action.payload.text, x: action.payload.x, y: action.payload.y, display: true } };
        case "SET_TOOLTIP_VISIBLE":
            return { ...state, tooltip: { ...state.tooltip, visible: action.payload } };
        case "HIDE_TOOLTIP":
            return { ...state, tooltip: { ...state.tooltip, visible: false } };
        case "SET_TOOLTIP_DISPLAY":
            return { ...state, tooltip: { ...state.tooltip, display: action.payload } };
        default:
            return state;
    }
}

export function AppProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const showTimeout = useRef(null);
    const hideTimeout = useRef(null);

    const showTooltip = (e, text) => {
        if (state.orientation === "landscape") {
            const rect = e.currentTarget.getBoundingClientRect();
            clearTimeout(hideTimeout.current);
            let ypos = rect.top - rect.height / 2;
            if (ypos < 0) {
                ypos = rect.top + rect.height + 10;
            }
            dispatch({
                type: "SHOW_TOOLTIP",
                payload: {
                    text,
                    x: rect.left + rect.width / 2,
                    y: ypos,
                },
            });
            dispatch({ type: "SET_TOOLTIP_DISPLAY", payload: true });
            showTimeout.current = setTimeout(() => {
                dispatch({ type: "SET_TOOLTIP_VISIBLE", payload: true });
            }, 100);
        }
    };

    const hideTooltip = () => {
        clearTimeout(showTimeout.current);
        dispatch({ type: "HIDE_TOOLTIP" });
        hideTimeout.current = setTimeout(() => {
            dispatch({ type: "SET_TOOLTIP_DISPLAY", payload: false });
        }, 300);
    };

    return (
        <AppContext.Provider value={{ state, dispatch, showTooltip, hideTooltip }}        >
            {children}
            {state.tooltip?.display && (
                <div
                    className="tooltip"
                    style={{
                        left: state.tooltip.x,
                        top: state.tooltip.y,
                        opacity: state.tooltip.visible ? 1 : 0
                    }}
                >
                    {state.tooltip.text}
                </div>
            )}
        </AppContext.Provider>
    );
}
